import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';
import { Product } from '../../../models/product';
import { ProductApiService } from '../../../services/apis/product-api.service';
import { ProductListItem } from '../../product/product-list-item/product-list-item';

@Component({
  selector: 'section[app-home-new-arrivals]',
  imports: [RouterModule, MatIconModule, ProductListItem, ShowleftDirective],
  templateUrl: './home-new-arrivals.html',
  styleUrl: './home-new-arrivals.scss',
})
export class HomeNewArrivals implements OnInit {
  readonly loadingPlaceholders = Array.from({ length: 5 });

  get newArrivalsNo() {
    return environment.collection.new_arrivals;
  }

  constructor(private productApi: ProductApiService) {

  }

  ngOnInit(): void {
    this.findProducts();
  }

  loading: boolean = false;
  items: Product[] = [];
  async findProducts() {
    try {
      this.loading = true;
      const r = await this.productApi.findProductCollectionProducts(this.newArrivalsNo, { page: 1, page_size: 5 });
      this.items = r.items;
    } catch (error) {

    } finally {
      this.loading = false;
    }
  }
}
